import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const BunnyStepBack = () => {
  const [start, setStart] = useState(60);
  const [jump1, setJump1] = useState(10);
  const [jump2, setJump2] = useState(3);
  const [correctAnswer, setCorrectAnswer] = useState(47);
  const [feedback, setFeedback] = useState('');
  const [input, setInput] = useState('');
  const [question, setQuestion] = useState('');
  const [max, setMax] = useState(100);
  const [bunnyLeft, setBunnyLeft] = useState(0);

  const lineRef = useRef(null);
  const bunnyRef = useRef(null);
  const tickRefs = useRef([]);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#fffdf6',
      color: '#333',
      padding: '2rem 1rem',
      minHeight: '100vh',
      boxSizing: 'border-box',
    },
    container: {
      maxWidth: '640px',
      margin: '0 auto',
      background: '#fefefe',
      padding: '2rem',
      borderRadius: '1rem',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      textAlign: 'center',
    },
    heading: {
      fontSize: '2rem',
      color: '#ff69b4',
      marginBottom: '1rem',
    },
    question: {
      fontSize: '1.2rem',
      marginBottom: '1rem',
    },
    numberLine: {
      position: 'relative',
      height: '100px',
      background: '#e0f7fa',
      borderRadius: '12px',
      padding: '10px',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      marginBottom: '2rem',
    },
    tick: {
      display: 'inline-block',
      width: '40px',
      textAlign: 'center',
      position: 'relative',
    },
    tickLine: {
      width: '2px',
      height: '20px',
      background: '#000',
      margin: '0 auto',
    },
    tickNumber: {
      fontSize: '0.75rem',
      marginTop: '4px',
    },
    bunny: {
      width: '40px',
      position: 'absolute',
      bottom: '60px',
      transition: 'left 0.8s ease',
    },
    input: {
      fontSize: '1.2rem',
      padding: '0.6rem 1rem',
      borderRadius: '0.75rem',
      border: '2px solid #ff69b4',
      width: '100%',
      maxWidth: '140px',
      textAlign: 'center',
      margin: '0 auto 1rem',
      display: 'block',
    },
    button: {
      fontSize: '1rem',
      padding: '0.6rem 1.2rem',
      margin: '0.5rem',
      borderRadius: '0.75rem',
      border: '2px solid #ff69b4',
      background: '#ff69b4',
      color: 'white',
      cursor: 'pointer',
      fontWeight: 600,
    },
    feedback: {
      fontSize: '1.2rem',
      fontWeight: 600,
      marginTop: '1rem',
      minHeight: '2rem',
    },
  };

  const loadQuestion = () => {
    const s = Math.floor(Math.random() * 21) + 60; // 60–80
    const j1 = Math.floor(Math.random() * 6) + 5;  // 5–10
    const j2 = Math.floor(Math.random() * 4) + 2;  // 2–5
    const result = s - j1 - j2;

    setStart(s);
    setJump1(j1);
    setJump2(j2);
    setCorrectAnswer(result);
    setInput('');
    setFeedback('');
    setQuestion(`Bunny starts at ${s}, jumps back ${j1}, then ${j2} more. Where is he now?`);
    setMax(s + 10);
  };

  const moveBunny = (position) => {
    const tick = tickRefs.current[position];
    if (tick && bunnyRef.current) {
      setBunnyLeft(tick.offsetLeft + 5); // Adjust bunny to tick
    }
  };

  const animateSteps = () => {
    moveBunny(start);
    setTimeout(() => moveBunny(start - jump1), 1000);
    setTimeout(() => moveBunny(start - jump1 - jump2), 2000);
  };

  const checkAnswer = () => {
    const ans = parseInt(input);
    if (ans === correctAnswer) {
      setFeedback("🎉 Yay! You got it right!");
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback("❌ Not quite. Try again!");
    }
  };

  useEffect(() => {
    loadQuestion();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      animateSteps();
    }, 100);
  }, [max]);

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.heading}>🐰 Step Back with the Bunny</h1>
        <div style={styles.question}>{question}</div>

        <div style={styles.numberLine} ref={lineRef}>
          <img
            src="https://classroomclipart.com/image/static7/preview2/cute-cartoon-of-a-smiling-bunny-rabbit-with-large-pink-ears-65848.jpg"
            alt="Bunny"
            ref={bunnyRef}
            style={{ ...styles.bunny, left: bunnyLeft }}
          />
          {Array.from({ length: max + 1 }).map((_, i) => (
            <div
              key={i}
              ref={(el) => (tickRefs.current[i] = el)}
              style={styles.tick}
            >
              <div style={styles.tickLine}></div>
              <div style={styles.tickNumber}>{i}</div>
            </div>
          ))}
        </div>

        <input
          type="number"
          placeholder="Where?"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={styles.input}
        />
        <button onClick={checkAnswer} style={styles.button}>Check</button>
        <button onClick={loadQuestion} style={styles.button}>Next</button>

        <div
          style={{
            ...styles.feedback,
            color: feedback.includes("Yay") ? "#2e7d32" : "#c62828",
          }}
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default BunnyStepBack;
